import { useEffect, useState } from 'react';
import { VelaMark } from './VelaMark';
import { LINKS } from '../config';

const NAV_LINKS = [
  { label: 'Features', href: '#features' },
  { label: 'Security', href: '#security' },
  { label: 'How it works', href: '#how-it-works' },
  { label: 'FAQ', href: '#faq' },
];

export function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-midnight-950/80 backdrop-blur-md border-b border-white/[0.06]' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <a href="#top" className="flex items-center gap-2.5">
          <VelaMark size={30} />
          <span className="font-display text-[1.05rem] tracking-wide text-star">Vela Wallet</span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-mist transition-colors hover:text-star"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href={LINKS.chromeWebStore}
          className="group inline-flex items-center gap-2 rounded-full bg-teal px-4 py-2 text-sm font-medium text-midnight-950 shadow-glow transition-transform hover:scale-[1.03] active:scale-[0.98]"
        >
          Add to Chrome
          <span aria-hidden="true" className="transition-transform group-hover:translate-x-0.5">
            →
          </span>
        </a>
      </div>
    </header>
  );
}
